// import React, { useEffect, useState, useCallback } from "react";
// import { useSelector } from "react-redux";
// import { selectState } from "../../store/slices/themeSlice";
// import useCustomStyles from "../../hooks/useCustomStyles";
// import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
// import CustomButton from "../../components/CustomButton";
// import syncAnimation from '../../assets/images/icon-sync-animated.gif';
// import syncAnimationStop from '../../assets/images/icon-sync-animated.svg';

// interface ReportUser {
//   id: string;
//   email: string;
//   user_name?: string;
//   created_at: { _seconds: number; _nanoseconds: number } | null;
//   clientId?: string | null;
//   business_name?: string | null;
//   accessCodes?: Array<{ id: string; expire_at: string }>;
// }

// interface ClientBreakdownEntry {
//   id: string;
//   clientId: string;
//   type: string;
//   created_at: { _seconds: number; _nanoseconds: number } | null;
//   users_count: number;
//   status: "active" | "inactive";
//   signups: ReportUser[];
// }

// interface AccessCodeEntry {
//   id: string;
//   codeType: string;
//   role_type: string;
//   expire_at: string;
//   validated: boolean;
//   shared: boolean;
//   created_at: { _seconds: number; _nanoseconds: number } | null;
// }

// interface MonthlyReportResponse {
//   business: string;
//   month: string;
//   activeClientsCount: number;
//   totalClientsCount: number;
//   accessCodesCount: number;
//   accessCodesList: AccessCodeEntry[];
//   clientBreakdown: ClientBreakdownEntry[];
//   unmatchedUsers: ReportUser[];
// }

// const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
// const BASE_URL = "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// const formatTimestamp = (ts: { _seconds: number } | null | undefined) => {
//   if (!ts?._seconds) return "N/A";
//   return new Date(ts._seconds * 1000).toLocaleDateString();
// };

// const currentMonth = () => new Date().toISOString().slice(0, 7);

// interface Props {
//   businessId: string;
// }

// const BusinessMonthlyReport: React.FC<Props> = ({ businessId }) => {
//   const { theme } = useSelector(selectState);
//   const classes = useCustomStyles(accessCodesStyles, theme);

//   const [month, setMonth] = useState<string>(currentMonth());
//   const [report, setReport] = useState<MonthlyReportResponse | null>(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [expandedClientId, setExpandedClientId] = useState<string | null>(null);

//   const fetchReport = useCallback(async (targetMonth: string) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await fetch(`${SERVER_URL}/getMonthlyBusinessReport`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ businessId, month: targetMonth }),
//       });
//       const data = await res.json();
//       if (!res.ok) {
//         throw new Error(data.message || "Failed to load report");
//       }
//       setReport(data);
//     } catch (e: any) {
//       setError(e.message || "Failed to load report");
//       setReport(null);
//     } finally {
//       setLoading(false);
//     }
//   }, [businessId]);

//   useEffect(() => {
//     fetchReport(month);
//   }, [month, fetchReport]);

//   const primaryColor = theme?.colorSchema?.colors?.primary || "#2196F3";

//   const styles: Record<string, React.CSSProperties> = {
//     controlsRow: {
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       marginBottom: "20px",
//     },
//     monthInput: {
//       padding: "8px 12px",
//       borderRadius: "6px",
//       border: "1px solid #ddd",
//       fontSize: "14px",
//     },
//     summaryGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
//       gap: "12px",
//       marginBottom: "24px",
//     },
//     summaryCard: {
//       backgroundColor: "#fff",
//       borderRadius: "10px",
//       padding: "16px",
//       boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//       textAlign: "center" as const,
//     },
//     summaryValue: {
//       fontSize: "24px",
//       fontWeight: 700,
//       color: primaryColor,
//     },
//     summaryLabel: {
//       fontSize: "12px",
//       color: "#666",
//       marginTop: "4px",
//       textTransform: "uppercase" as const,
//     },
//     sectionTitle: {
//       fontSize: "16px",
//       fontWeight: 600,
//       marginBottom: "12px",
//       marginTop: "24px",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse" as const,
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       overflow: "hidden",
//       boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
//     },
//     th: {
//       textAlign: "left" as const,
//       padding: "10px 12px",
//       fontSize: "12px",
//       textTransform: "uppercase" as const,
//       color: "#666",
//       borderBottom: "1px solid #eee",
//       backgroundColor: "#fafafa",
//     },
//     td: {
//       padding: "10px 12px",
//       fontSize: "13px",
//       borderBottom: "1px solid #f2f2f2",
//     },
//     statusBadgeActive: {
//       padding: "3px 10px",
//       borderRadius: "12px",
//       fontSize: "11px",
//       fontWeight: 500,
//       backgroundColor:  "#e8f5e9",
//       color: "#2e7d32",
//     },
//     statusBadgeInActive: {
//         padding: "3px 10px",
//         borderRadius: "12px",
//         fontSize: "11px",
//         fontWeight: 500,
//         backgroundColor:  "#fbe9e7",
//         color: "#c62828",
//       },
//     signupsRow: {
//       backgroundColor: "#fafafa",
//     },
//     codeBadge: {
//       display: "inline-block",
//       padding: "2px 8px",
//       borderRadius: "6px",
//       backgroundColor: "#eef2ff",
//       color: "#3730a3",
//       fontSize: "11px",
//       fontFamily: "monospace",
//       marginRight: "4px",
//     },
//     expandTrigger: {
//       cursor: "pointer",
//       color: primaryColor,
//       fontSize: "12px",
//       fontWeight: 500,
//     },
//   };

//   return (
//     <div>
//       <div style={styles.controlsRow}>
//         <label style={{ fontSize: "14px", fontWeight: 500 }}>Month:</label>
//         <input
//           type="month"
//           value={month}
//           max={currentMonth()}
//           onChange={(e) => setMonth(e.target.value)}
//           style={styles.monthInput}
//         />
//         <img
//             src={ loading? syncAnimation : syncAnimationStop }
//             alt="Refresh"
//             onClick={() => !loading && fetchReport(month)}
//             style={{
//                 width:loading? 36 : 28,
//                 height:loading? 36 : 28,
//                 cursor: loading ? 'default' : 'pointer',
//                 opacity: loading ? 0.7 : 1,
//             }}
//             />
//         {/* <CustomButton
//           title="Refresh"
//           name="refreshReport"
//           handleClick={() => fetchReport(month)}
//           variant="secondary"
//           loading={loading}
//         /> */}

//       </div>

//       {error && (
//         <div style={{ padding: "12px", backgroundColor: "#fbe9e7", borderRadius: "8px", color: "#c62828", marginBottom: "16px" }}>
//           {error}
//         </div>
//       )}

//       {loading && !report && <p>Loading report...</p>}

//       {report && (
//         <>
//           {/* Summary cards */}
//           <div style={styles.summaryGrid}>
//             <div style={styles.summaryCard}>
//               <div style={styles.summaryValue}>{report.activeClientsCount}</div>
//               <div style={styles.summaryLabel}>Total Active Users</div>
//             </div>
//             <div style={styles.summaryCard}>
//               <div style={styles.summaryValue}>{report.totalClientsCount}</div>
//               <div style={styles.summaryLabel}>Total Client IDs</div>
//             </div>
//             <div style={styles.summaryCard}>
//               <div style={styles.summaryValue}>{report.accessCodesCount}</div>
//               <div style={styles.summaryLabel}>Licenses (Access Codes)</div>
//             </div>
//           </div>

//           {/* Client ID breakdown */}
//           <h4 style={styles.sectionTitle}>Client IDs — as of {report.month}</h4>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>Client ID</th>
//                 <th style={styles.th}>Type</th>
//                 <th style={styles.th}>Created</th>
//                 <th style={styles.th}>Status</th>
//                 <th style={styles.th}>Users</th>
//                 <th style={styles.th}></th>
//               </tr>
//             </thead>
//             <tbody>
//               {report.clientBreakdown.map((c) => (
//                 <React.Fragment key={c.id}>
//                   <tr>
//                     <td style={styles.td}>{c.clientId}</td>
//                     <td style={styles.td}>{c.type}</td>
//                     <td style={styles.td}>{formatTimestamp(c.created_at)}</td>
//                     <td style={styles.td}>
//                       <span style={c.status === "active"? styles.statusBadgeActive : styles.statusBadgeInActive}>{c.status}</span>
//                     </td>
//                     <td style={styles.td}>{c.users_count}</td>
//                     <td style={styles.td}>
//                       {c.signups.length > 0 && (
//                         <span
//                           style={styles.expandTrigger}
//                           onClick={() => setExpandedClientId(expandedClientId === c.clientId ? null : c.clientId)}
//                         >
//                           {expandedClientId === c.clientId ? "Hide" : "View"} signups
//                         </span>
//                       )}
//                     </td>
//                   </tr>
//                   {expandedClientId === c.clientId && (
//                     <tr style={styles.signupsRow}>
//                       <td style={styles.td} colSpan={6}>
//                         {c.signups.map((u) => (
//                           <div key={u.id} style={{ padding: "6px 0", borderBottom: "1px solid #eee" }}>
//                             <strong>{u.user_name || u.email}</strong> — {u.email} — signed up {formatTimestamp(u.created_at)}
//                             {u.accessCodes?.map((code) => (
//                               <span key={code.id} style={styles.codeBadge}>{code.id}</span>
//                             ))}
//                           </div>
//                         ))}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           {/* Unmatched users (no clientId, or unrecognized clientId) */}
//           {report.unmatchedUsers.length > 0 && (
//             <>
//               <h4 style={styles.sectionTitle}>Signups without a Client ID</h4>
//               <table style={styles.table}>
//                 <thead>
//                   <tr>
//                     <th style={styles.th}>Name</th>
//                     <th style={styles.th}>Email</th>
//                     <th style={styles.th}>Created</th>
//                     <th style={styles.th}>Access Code(s)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {report.unmatchedUsers.map((u) => (
//                     <tr key={u.id}>
//                       <td style={styles.td}>{u.user_name || "N/A"}</td>
//                       <td style={styles.td}>{u.email}</td>
//                       <td style={styles.td}>{formatTimestamp(u.created_at)}</td>
//                       <td style={styles.td}>
//                         {u.accessCodes?.map((code) => (
//                           <span key={code.id} style={styles.codeBadge}>{code.id}</span>
//                         ))}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </>
//           )}

//           {/* Access codes / licenses list */}
//           <h4 style={styles.sectionTitle}>Licenses — as of {report.month}</h4>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>Code</th>
//                 <th style={styles.th}>Type</th>
//                 <th style={styles.th}>Role</th>
//                 <th style={styles.th}>Expires</th>
//                 <th style={styles.th}>Validated</th>
//                 <th style={styles.th}>Shared</th>
//                 <th style={styles.th}>Created</th>
//               </tr>
//             </thead>
//             <tbody>
//               {report.accessCodesList.map((code) => (
//                 <tr key={code.id}>
//                   <td style={styles.td}><span style={styles.codeBadge}>{code.id}</span></td>
//                   <td style={styles.td}>{code.codeType}</td>
//                   <td style={styles.td}>{code.role_type}</td>
//                   <td style={styles.td}>{code.expire_at}</td>
//                   <td style={styles.td}>{code.validated ? "Yes" : "No"}</td>
//                   <td style={styles.td}>{code.shared ? "Yes" : "No"}</td>
//                   <td style={styles.td}>{formatTimestamp(code.created_at)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </>
//       )}
//     </div>
//   );
// };

// export default BusinessMonthlyReport;

import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectState } from "../../store/slices/themeSlice";
import useCustomStyles from "../../hooks/useCustomStyles";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import CustomButton from "../../components/CustomButton";
import syncAnimation from '../../assets/images/icon-sync-animated.gif';
import syncAnimationStop from '../../assets/images/icon-sync-animated.svg';

interface ReportUser {
  id: string;
  email: string;
  user_name?: string;
  created_at: { _seconds: number; _nanoseconds: number } | null;
  clientId?: string | null;
  business_name?: string | null;
  accessCodes?: Array<{ id: string; expire_at: string }>;
}

interface ClientBreakdownEntry {
  id: string;
  clientId: string;
  type: string;
  created_at: { _seconds: number; _nanoseconds: number } | null;
  users_count: number;
  status: "active" | "inactive";
  signups: ReportUser[];
  // Only populated (by the backend) for clientIds of type "Business ID".
  // Adjust the field name here if the Cloud Function response uses a different key.
  allowedSignups?: number | null;
}

interface AccessCodeEntry {
  id: string;
  codeType: string;
  role_type: string;
  expire_at: string;
  validated: boolean;
  shared: boolean;
  created_at: { _seconds: number; _nanoseconds: number } | null;
}

interface MonthlyReportResponse {
  business: string;
  month: string;
  activeClientsCount: number;
  totalClientsCount: number;
  accessCodesCount: number;
  accessCodesList: AccessCodeEntry[];
  clientBreakdown: ClientBreakdownEntry[];
  unmatchedUsers: ReportUser[];
}

const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
const BASE_URL = "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// Wired to the v2 endpoint (functions/v2/endpoints/businessReportEndpoints.ts
// → getMonthlyBusinessReport_v2), which reads partnerClientIds_v2 /
// accessCodes_v2 / users_v2 and finds "redeemed but no recognized clientId"
// users via accessCodeUsages_v2 instead of v1's array-contains-any scan.
// Public, matching v1 (no Authorization header sent here either). Pointed
// at BASE_URL (functions emulator) for pre-deploy testing — set
// REPORT_V2_DEPLOYED = true after
// `firebase deploy --only functions:getMonthlyBusinessReport_v2`.
const REPORT_V2_DEPLOYED = true;
const REPORT_V2_URL = REPORT_V2_DEPLOYED ? SERVER_URL : BASE_URL;

const formatTimestamp = (ts: { _seconds: number } | null | undefined) => {
  if (!ts?._seconds) return "N/A";
  return new Date(ts._seconds * 1000).toLocaleDateString();
};

const currentMonth = () => new Date().toISOString().slice(0, 7);

// Clients of this type have a configured cap on how many users may sign up.
const BUSINESS_ID_TYPE = "Business ID";

interface Props {
  businessId: string;
}

const BusinessMonthlyReport: React.FC<Props> = ({ businessId }) => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(accessCodesStyles, theme);

  const [month, setMonth] = useState<string>(currentMonth());
  const [report, setReport] = useState<MonthlyReportResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedClientId, setExpandedClientId] = useState<string | null>(null);

  const fetchReport = useCallback(async (targetMonth: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${REPORT_V2_URL}getMonthlyBusinessReport_v2`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ businessId, month: targetMonth }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || "Failed to load report");
      }
      console.error('report from backend', data)
      setReport(data);
    } catch (e: any) {
      setError(e.message || "Failed to load report");
      setReport(null);
    } finally {
      setLoading(false);
    }
  }, [businessId]);

  useEffect(() => {
    fetchReport(month);
  }, [month, fetchReport]);

  const primaryColor = theme?.colorSchema?.colors?.primary || "#2196F3";

  const styles: Record<string, React.CSSProperties> = {
    controlsRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "20px",
    },
    monthInput: {
      padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ddd",
      fontSize: "14px",
    },
    summaryGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
      gap: "12px",
      marginBottom: "24px",
    },
    summaryCard: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "16px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      textAlign: "center" as const,
    },
    summaryValue: {
      fontSize: "24px",
      fontWeight: 700,
      color: primaryColor,
    },
    summaryLabel: {
      fontSize: "12px",
      color: "#666",
      marginTop: "4px",
      textTransform: "uppercase" as const,
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      marginBottom: "12px",
      marginTop: "24px",
    },
    tableWrapper: {
      width: "100%",
      overflowX: "auto" as const,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse" as const,
      backgroundColor: "#fff",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    },
    th: {
      textAlign: "left" as const,
      padding: "10px 12px",
      fontSize: "12px",
      textTransform: "uppercase" as const,
      color: "#666",
      borderBottom: "1px solid #eee",
      backgroundColor: "#fafafa",
    },
    td: {
      padding: "10px 12px",
      fontSize: "13px",
      borderBottom: "1px solid #f2f2f2",
    },
    statusBadgeActive: {
      padding: "3px 10px",
      borderRadius: "12px",
      fontSize: "11px",
      fontWeight: 500,
      backgroundColor:  "#e8f5e9",
      color: "#2e7d32",
    },
    statusBadgeInActive: {
        padding: "3px 10px",
        borderRadius: "12px",
        fontSize: "11px",
        fontWeight: 500,
        backgroundColor:  "#fbe9e7",
        color: "#c62828",
      },
    signupsRow: {
      backgroundColor: "#fafafa",
    },
    codeBadge: {
      display: "inline-block",
      padding: "2px 8px",
      borderRadius: "6px",
      backgroundColor: "#eef2ff",
      color: "#3730a3",
      fontSize: "11px",
      fontFamily: "monospace",
      marginRight: "4px",
    },
    expandTrigger: {
      cursor: "pointer",
      color: primaryColor,
      fontSize: "12px",
      fontWeight: 500,
    },
    capText: {
      fontSize: "12px",
      color: "#666",
    },
    capTextWarn: {
      fontSize: "12px",
      color: "#c62828",
      fontWeight: 600,
    },
  };

  return (
    <div>
      <div style={styles.controlsRow}>
        <label style={{ fontSize: "14px", fontWeight: 500 }}>Month:</label>
        <input
          type="month"
          value={month}
          max={currentMonth()}
          onChange={(e) => setMonth(e.target.value)}
          style={styles.monthInput}
        />
        <img
            src={ loading? syncAnimation : syncAnimationStop }
            alt="Refresh"
            onClick={() => !loading && fetchReport(month)}
            style={{
                width:loading? 36 : 28,
                height:loading? 36 : 28,
                cursor: loading ? 'default' : 'pointer',
                opacity: loading ? 0.7 : 1,
            }}
            />
        {/* <CustomButton
          title="Refresh"
          name="refreshReport"
          handleClick={() => fetchReport(month)}
          variant="secondary"
          loading={loading}
        /> */}

      </div>

      {error && (
        <div style={{ padding: "12px", backgroundColor: "#fbe9e7", borderRadius: "8px", color: "#c62828", marginBottom: "16px" }}>
          {error}
        </div>
      )}

      {loading && !report && <p>Loading report...</p>}

      {report && (
        <>
          {/* Summary cards */}
          <div style={styles.summaryGrid}>
            <div style={styles.summaryCard}>
              <div style={styles.summaryValue}>{report.activeClientsCount}</div>
              <div style={styles.summaryLabel}>Total Active Users</div>
            </div>
            <div style={styles.summaryCard}>
              <div style={styles.summaryValue}>{report.totalClientsCount}</div>
              <div style={styles.summaryLabel}>Total Client IDs</div>
            </div>
            <div style={styles.summaryCard}>
              <div style={styles.summaryValue}>{report.accessCodesCount}</div>
              <div style={styles.summaryLabel}>Licenses (Access Codes)</div>
            </div>
          </div>

          {/* Client ID breakdown */}
          <h4 style={styles.sectionTitle}>Client IDs — as of {report.month}</h4>
          <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Client ID</th>
                <th style={styles.th}>Type</th>
                <th style={styles.th}>Created</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Users</th>
                <th style={styles.th}>Allowed Signups</th>
                <th style={styles.th}></th>
              </tr>
            </thead>
            <tbody>
              {report.clientBreakdown.map((c) => {
                const isBusinessId = c.type === BUSINESS_ID_TYPE;
                const hasCap = isBusinessId && c.allowedSignups != null;
                const overCap = hasCap && c.users_count > (c.allowedSignups as number);
                return (
                <React.Fragment key={c.id}>
                  <tr>
                    <td style={styles.td}>{c.clientId}</td>
                    <td style={styles.td}>{c.type}</td>
                    <td style={styles.td}>{formatTimestamp(c.created_at)}</td>
                    <td style={styles.td}>
                      <span style={c.status === "active"? styles.statusBadgeActive : styles.statusBadgeInActive}>{c.status}</span>
                    </td>
                    <td style={styles.td}>{c.users_count}</td>
                    <td style={styles.td}>
                      
                          <span style={overCap ? styles.capTextWarn : styles.capText}>
                            {c.users_count} / {c.allowedSignups}
                          </span>
                      
                    </td>
                    <td style={styles.td}>
                      {c.signups.length > 0 && (
                        <span
                          style={styles.expandTrigger}
                          onClick={() => setExpandedClientId(expandedClientId === c.clientId ? null : c.clientId)}
                        >
                          {expandedClientId === c.clientId ? "Hide" : "View"} signups
                        </span>
                      )}
                    </td>
                  </tr>
                  {expandedClientId === c.clientId && (
                    <tr style={styles.signupsRow}>
                      <td style={styles.td} colSpan={7}>
                        {c.signups.map((u) => (
                          <div key={u.id} style={{ padding: "6px 0", borderBottom: "1px solid #eee" }}>
                            <strong>{u.user_name || u.email}</strong> — {u.email} — signed up {formatTimestamp(u.created_at)}
                            {u.accessCodes?.map((code) => (
                              <span key={code.id} style={styles.codeBadge}>{code.id}</span>
                            ))}
                          </div>
                        ))}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
                );
              })}
            </tbody>
          </table>
          </div>

          {/* Unmatched users (no clientId, or unrecognized clientId) */}
          {report.unmatchedUsers.length > 0 && (
            <>
              <h4 style={styles.sectionTitle}>Signups without a Client ID</h4>
              <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Name</th>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Created</th>
                    <th style={styles.th}>Access Code(s)</th>
                  </tr>
                </thead>
                <tbody>
                  {report.unmatchedUsers.map((u) => (
                    <tr key={u.id}>
                      <td style={styles.td}>{u.user_name || "N/A"}</td>
                      <td style={styles.td}>{u.email}</td>
                      <td style={styles.td}>{formatTimestamp(u.created_at)}</td>
                      <td style={styles.td}>
                        {u.accessCodes?.map((code) => (
                          <span key={code.id} style={styles.codeBadge}>{code.id}</span>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </>
          )}

          {/* Access codes / licenses list */}
          <h4 style={styles.sectionTitle}>Licenses — as of {report.month}</h4>
          <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Code</th>
                <th style={styles.th}>Type</th>
                <th style={styles.th}>Role</th>
                <th style={styles.th}>Expires</th>
                <th style={styles.th}>Validated</th>
                <th style={styles.th}>Shared</th>
                <th style={styles.th}>Created</th>
              </tr>
            </thead>
            <tbody>
              {report.accessCodesList.map((code) => (
                <tr key={code.id}>
                  <td style={styles.td}><span style={styles.codeBadge}>{code.id}</span></td>
                  <td style={styles.td}>{code.codeType}</td>
                  <td style={styles.td}>{code.role_type}</td>
                  <td style={styles.td}>{code.expire_at}</td>
                  <td style={styles.td}>{code.validated ? "Yes" : "No"}</td>
                  <td style={styles.td}>{code.shared ? "Yes" : "No"}</td>
                  <td style={styles.td}>{formatTimestamp(code.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </>
      )}
    </div>
  );
};

export default BusinessMonthlyReport;